import { AdminMatchTeams } from '@platform/client';
import { useParams } from 'wouter';
import { AdminDetailPage } from '../../AdminDetailPage';
import { DetailsTabContent } from './DetailsTabContent';

export const TeamMatchDetail = () => {
  const { discoveryId } = useParams<{ discoveryId: string }>();
  const {
    data: matchData,
    isLoading,
    isSuccess,
  } = AdminMatchTeams.useGetAdminTeamMatchDetails(parseInt(discoveryId));

  return (
    <>
      <AdminDetailPage
        title={
          matchData?.teamMatchDetails?.teamDiscoveryId ?
            `Team Discovery #${matchData.teamMatchDetails.teamDiscoveryId}`
          : 'Team Discovery Details'
        }
        isLoading={isLoading}
        isSuccess={isSuccess}
        tabs={[
          {
            id: 'Details',
            content: (
              <DetailsTabContent
                teamMatchData={matchData?.teamMatchDetails}
                projectPlanData={matchData?.projectPlan}
              />
            ),
          },
        ]}
      />
    </>
  );
};
